import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NavParams, ViewController } from "ionic-angular";

export interface FieldError {
  fieldName: string;
  errorMessages: string[];
}

export interface CategoryGroup {
  categoryName: string;
  fields: FieldError[];
}

@Component({
  selector: "upload-error",
  templateUrl: "upload-error.html",
})
export class UploadError {
  categoryGroups: CategoryGroup[] = [];

  constructor(
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private translate: TranslateService
  ) {}

  ionViewDidLoad() {
    const errorList = this.navParams.get("errorList") || {};
    this.processErrors(errorList);
  }

  processErrors(errorList: { [key: string]: string[] }) {
    // Group errors by category
    const categoryMap = new Map<string, Map<string, string[]>>();

    for (const key in errorList) {
      if (errorList.hasOwnProperty(key)) {
        const parts = key.split("_");

        if (parts.length === 2) {
          const categoryKey = parts[0]; // e.g., "bathing"
          const fieldKey = parts[1]; // e.g., "haBedFull"
          const errorMessages = errorList[key];

          // Get or create category map
          if (!categoryMap.has(categoryKey)) {
            categoryMap.set(categoryKey, new Map<string, string[]>());
          }

          // Add field to category
          categoryMap.get(categoryKey).set(fieldKey, errorMessages);
        }
      }
    }

    // Convert map to array structure
    this.categoryGroups = [];
    categoryMap.forEach((fields, categoryKey) => {
      const categoryName = this.translate.instant(categoryKey);
      const fieldErrors: FieldError[] = [];

      fields.forEach((errorMessages, fieldKey) => {
        const fieldName = this.translate.instant(fieldKey);
        fieldErrors.push({ fieldName, errorMessages });
      });

      this.categoryGroups.push({
        categoryName,
        fields: fieldErrors,
      });
    });
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/assessment/visits/upload-error/upload-error.ts